var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_vm._v("地址输入错误或暂无该企业信息！")])}
var staticRenderFns = []

export { render, staticRenderFns }